
















import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {Component, Watch} from "vue-property-decorator";
import ManageCodCustomerPayed from "@/modules/managecodcustomer/ListPayed/index.vue";
import ManageCodCustomerNotYetPay from "@/modules/managecodcustomer/ListNotYetPay/index.vue";
import MillisecondMonthPicker from "@/shared/components/MillisecondMonthPicker/index.vue";
import {ManageCodParams} from "@/modules/managecodcustomer/params";
import {ManageCodStore} from "@/modules/managecodcustomer/store";
import {DebtCustomerStatus} from "@/enums/status";
import moment from "moment";

@Component({
    name: "ManageFeeCustomer",
    components: {
        MillisecondMonthPicker,
        ManageCodCustomerNotYetPay,
        ManageCodCustomerPayed,
    }
})
export default class extends mixins(CommonMixin) {
    params = new ManageCodParams();

    @Watch('params', { deep: true, immediate: true })
    onChangeParams(val) {
        const toDate = moment(val?.fromDate).endOf('month').valueOf();
        ManageCodStore.paramPayedManageCodChange({...val, page: 1, status: DebtCustomerStatus.Payed, toDate});
        ManageCodStore.paramNotPayManageCodChange({...val, page: 1, status: DebtCustomerStatus.NotYetPay, toDate});
    }
}
